// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wY3B","top":"styles_top__1xKgR"};